import React, { useState, useRef, useEffect } from "react";
import { View, TextInput, StyleSheet } from "react-native";
import { Observer, observer } from "mobx-react";
import { Octicons } from "@expo/vector-icons";
import Colors from "../../Resources/Color";
import { useTranslation } from "react-i18next";
import Fonts from "../../Resources/Fonts";
import { useDevice } from "../_layout";

const SearchBar = ({
  text,
  onChangeText,
  onFocus,
  onBlur,
  onSubmitEditing,
  dark = false,
  placeholder,
  maxWidth,
  focusOnChange = false,
  changeKey = null,
  selectTextOnFocus = false,
  autoFocusOnDesktop = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useTranslation();
  const { isMobile } = useDevice();
  const textInputRef = useRef(null);
  const shouldAutoFocus = autoFocusOnDesktop && !isMobile;

  useEffect(() => {
    if (focusOnChange && changeKey && textInputRef.current && !isMobile) {
      textInputRef.current.focus();
    }
  }, [focusOnChange, changeKey]);

  return (
    <View
      style={[
        styles.searchBar,
        {
          backgroundColor: dark ? "transparent" : Colors.whiteColor,
          width: "100%",
          maxWidth: maxWidth ? maxWidth : 220,
          borderWidth: 0.2,
          borderColor: isHovered
            ? Colors.grayColor
            : dark
            ? Colors.grayColor
            : Colors.borderColor,
        },
      ]}
      onMouseEnter={() => !isMobile && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Octicons name="search" size={20} color={Colors.grayColor} />
      <TextInput
        ref={textInputRef}
        autoFocus={shouldAutoFocus}
        value={text}
        onChangeText={onChangeText}
        onFocus={onFocus}
        onBlur={onBlur}
        onSubmitEditing={onSubmitEditing}
        selectTextOnFocus={selectTextOnFocus && typeof text === "string" && text.length > 0}
        style={[
          styles.textInputStyle,
          {
            color: dark ? Colors.whiteColor : Colors.blackColor,
            outline: "none",
            width: "100%",
            fontSize: isMobile ? 16 : 14,
          },
        ]}
        placeholder={t(placeholder)}
        placeholderTextColor={Colors.grayColor}
        maxLength={50}
      />
    </View>
  );
};
const styles = StyleSheet.create({
  textInputStyle: {
    flex: 1,
    paddingHorizontal: 8,
    borderRadius: 14,
    borderWidth: 0,
    fontWeight: "400",
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    borderRadius: 14,
    height: 40,
  },
});

export default SearchBar;
